module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-800italic.51d1e834.eot";